import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ConsumerInformationView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    title: "Verbraucherinformationen",
    "flex-direction": "flex-column"
  }, {
    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", null, [
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: "pdf\\WAKAM_IPID.pdf",
            class: "link",
            target: "_blank"
          }, " Informationsblatt ")
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: "pdf\\WAKAM_Insurance_information.pdf",
            class: "link",
            target: "_blank"
          }, " Versicherungsinformationen ")
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: "pdf\\WAKAM_AKB.pdf",
            class: "link",
            target: "_blank"
          }, " Allgemeine Bedingungen für die Kfz-Haftpflichtversicherung (AKB) ")
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: "pdf\\WAKAM_GDPR.pdf",
            class: "link",
            target: "_blank"
          }, " Merkblatt zur Datenverarbeitung ")
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: "schaden",
            class: "link"
          }, " Schaden melden ")
        ])
      ], -1)
    ]))]),
    _: 1
  }))
}
}

})